(() =>
{
    const key = 'theme';
    const saved = localStorage.getItem(key);
    if (saved) document.documentElement.setAttribute('data-theme', saved);

    window.toggleTheme = () =>
    {
        const cur = document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', cur);
        localStorage.setItem(key, cur);
    };
})();
